const n="\n  id\n  altText\n  width\n  height\n  url\n";export{n as STOREFRONT_IMAGE_FRAGMENT};
//# sourceMappingURL=image.js.map
